module.exports = __webpack_public_path__ + "img/GP.83278f53.png";